import { injectReducer } from 'store/reducers'
import { injectSaga, cancelSaga } from '../../store/sagas'

export default (store) => ({
  path: 'versions(/:id)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const Versions = require('./containers/VersionsContainer').default
      const reducer = require('./modules/versions').default
      const saga = require('./modules/versions').mainSaga

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'versions', reducer })

      injectSaga(store, { key: 'versions', saga })

      /*  Return getComponent   */
      cb(null, Versions)

      /* Webpack named bundle   */
    }, 'versions')
  },

  onLeave() {
    cancelSaga(store, 'versions')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Button/routes/Versions/index.js